import React, { Component } from 'react'
import { policies } from '@services/api'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import { Table, Button, Icon, Input, Popconfirm } from 'antd'
import AddNewPolicyToCollection from '../../../../components/Popup/AddNewPolicyToCollection'
import { policyCollections } from '@services/api'

@inject((store: any) => {
    const { companiesStore, popupStore, collectionsStore } = store
    return { companiesStore, popupStore, collectionsStore }
})
@observer
class Policies extends Component<any, any> {
    state = { policies: [], policyId: '' }
    componentDidMount() {
        this.handleFetchRelevantPol()
    }

    componentDidUpdate(prevProps) {
        let { collectionPolicies } = this.props
        prevProps.collectionPolicies.length != collectionPolicies.length && this.handleFetchRelevantPol()
    }

    handleFetchRelevantPol() {
        policies
            .getRelevantPolicies(this.props.collectionPolicies.map(pol => pol.policy_id))
            .then(res => this.setState({ policies: res.data }))
    }

    async handleDlt(policy_id) {
        let collection_id = window.location.href.slice(window.location.href.split('/', 4).join('/').length + 1)
        await policyCollections.deleteCollection({
            policy_id,
            collection_id,
            fromTerms: true
        })
        this.props.collectionsStore.getCollection(collection_id)
    }

    render() {
        const { policies, policyId } = this.state
        const {
            popupStore: { togglePopup },
            companiesStore,
            history
        } = this.props
        const columns = [
            {
                title: 'שם',
                key: 'name',
                width: 150,
                align: 'center',
                render: (_, record) => <span>{record.name}</span>
            },
            {
                title: 'מזהה',
                key: 'id',
                width: 30,
                align: 'center',

                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'חברה',
                key: 'company',
                align: 'center',

                width: 100,
                render: (_, record) => <span>{companiesStore.list.find(com => com.id == record.company_id).name}</span>
            },
            {
                title: '',
                key: 'edit',
                width: 25,
                align: 'left',
                render: (_, record) => {
                    return (
                        <Button onClick={() => history.push(`/insurance/${record.company_id}/${record.id}`)}>
                            <Icon type="edit" />
                        </Button>
                    )
                }
            },
            {
                title: '',
                key: 'delete',
                width: 25,
                align: 'right',
                render: (_, record) => {
                    const { type, id } = record
                    const disabled = type !== 'PRIVATE' && type !== 'GROUP'
                    return (
                        <Popconfirm
                            disabled={disabled}
                            title="האם אתה בטוח שברצונך להסיר קישור לפוליסה זו?"
                            okText="מחק קישור לפוליסה"
                            cancelText="ביטול"
                            onConfirm={() => this.handleDlt(id)}
                        >
                            <Button disabled={disabled}>
                                <Icon type="delete" />
                            </Button>
                        </Popconfirm>
                    )
                }
            }
        ]
        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row', flex: 1, justifyContent: 'space-between' }}>
                    <h5>פוליסות רלוונטיות</h5>
                    <Input
                        placeholder="סנן על פי מזהה"
                        onChange={e => this.setState({ policyId: e.target.value })}
                        style={{ width: 150 }}
                    />
                    <Button
                        type="primary"
                        style={{ marginLeft: '0rem' }}
                        onClick={() => togglePopup('addNewPolicyToCollection', {})}
                    >
                        <Icon type="link" />
                        קישור פוליסה חדשה
                    </Button>
                </div>
                <Table
                    style={{ width: '100%' }}
                    rowKey="id"
                    columns={columns}
                    dataSource={policies.filter(pol => `${pol.id}`.includes(policyId))}
                    pagination={{
                        pageSize: 5
                    }}
                />
                <AddNewPolicyToCollection />
            </div>
        )
    }
}

export default withRouter(Policies)
